import { CountryPrefix } from 'Jsx/global';
import { DocumentTypeEnum } from 'Jsx/Types/Graphql/globals.payments';

export const getDocumentTypes = (
  countryPrefix: CountryPrefix,
): DocumentTypeEnum[] => {
  switch (countryPrefix) {
    case 'ar':
    case 'pe':
      return [DocumentTypeEnum.DNI];
    case 'br':
      return [DocumentTypeEnum.SSN];
    case 'co':
      return [DocumentTypeEnum.NIT, DocumentTypeEnum.CE, DocumentTypeEnum.CC];
    case 'mx':
      return [DocumentTypeEnum.SSN];
    default:
      return [DocumentTypeEnum.SSN];
  }
};
